import { toast } from 'react-toastify';
import { GetApi, PutApi, PostApi } from 'src/services/middleware';
import { ClaimHeadersWithoutSecret } from 'src/utils';

const ASSET_SERVICE_URL = process.env.REACT_APP_ASSET_SERVICE_URL;

const assetBase = `${ASSET_SERVICE_URL}/asset-service/api`;

export const getAllAssetClaims = async (data) => {
  return await PostApi(
    `${assetBase}/externalClaims`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetClaimStatus = async () => {
  return await GetApi(
    `${assetBase}/getExternalClaimsCountStatusWise`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const raiseAssetClaim = async (id, subId, data) => {
  return await PutApi(
    `${assetBase}/raiseExternalClaim/${id}/sub-claimId/${subId}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetVendorBySpecification = async (specification) => {
  return await GetApi(
    `${assetBase}/getVendorBySpecification/${specification}`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : []))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetClaimDetails = async (claimId, subClaimId) => {
  return await GetApi(
    `${assetBase}/getExternalClaimDetails/${claimId}/sub-claimId/${subClaimId}`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : []))
    .catch(() => toast.error('Something went wrong!'));
};

export const assetInProgressClaim = async (claimId, subClaimId, data) => {
  return await PutApi(
    `${assetBase}/isDocumentVerificationDone/${claimId}/sub-claimId/${subClaimId}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const rejectAssetClaim = async (claimId, subClaimId, data) => {
  return await PutApi(
    `${assetBase}/rejectExternalClaim/${claimId}/sub-claimId/${subClaimId}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const settleAssetClaim = async (data) => {
  return await PostApi(
    `${assetBase}/settleExternalClaim`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetInsuranceType = async (type) => {
  return await GetApi(
    `${assetBase}/getInsuranceTypesOfVendor?vendorCode=${type}`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : []))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetStatusHistory = async (id, subId) => {
  return await GetApi(
    `${assetBase}/getExternalStatusHistory/${id}/sub-claimId/${subId}`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const approveAssetClaim = async (claimId, subClaimId, data) => {
  return await PutApi(
    `${assetBase}/approveExternalClaim/${claimId}/sub-claimId/${subClaimId}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const queryAssetClaim = async (claimId, subClaimId, data) => {
  return await PutApi(
    `${assetBase}/queryExternalClaim/${claimId}/sub-claimId/${subClaimId}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetClaimTypes = async () => {
  return await GetApi(
    `${assetBase}/externalClaimTypes`,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetCategoryNames = async (reviewer, data) => {
  return await PostApi(
    `${assetBase}/category-names/${reviewer}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetReasonCategories = async (reviewer, data) => {
  return await PostApi(
    `${assetBase}/reason-categories/by-reviewer-type/${reviewer}`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAllAssetVendors = async () => {
  return await GetApi(`${assetBase}/getAllVendor`, ClaimHeadersWithoutSecret())
    .then((res) => (res?.status === 200 ? res?.data : []))
    .catch(() => toast.error('Something went wrong!'));
};

export const getAssetDocument = async (docId) => {
  return await GetApi(`${assetBase}/docs/${docId}`, ClaimHeadersWithoutSecret())
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};

export const assignAssetClaim = async (reviewer, data) => {
  return await PostApi(
    `${assetBase}/asset/reviewer/claims?role=ASSET_IO_REVIEWER`,
    data,
    ClaimHeadersWithoutSecret()
  )
    .then((res) => (res?.status === 200 ? res?.data : res))
    .catch(() => toast.error('Something went wrong!'));
};
